var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptimize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4494 18.4009H14.5788C18.0598 18.4009 19.4522 17.0085 19.4522 13.5276V9.35041C19.4522 5.86944 18.0598 4.47705 14.5788 4.47705H10.4017C6.92071 4.47705 5.52832 5.86944 5.52832 9.35041V11.432",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01758 4.47527V1.68701",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4902 4.47527V1.68701",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9717 4.47527V1.68701",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4521 7.9624H22.2404",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4521 11.4424H22.2404",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4521 14.9175H22.2404",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9717 18.4028V21.1911",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4988 18.4028V21.1911",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74023 7.9624H4.83577",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74023 11.4424H4.83577",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5255,
    cy: 11.4749,
    r: 2.09554,
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98935 19.169L2.32931 19.7578C2.5302 20.1058 2.9807 20.2293 3.33199 20.0265C3.93755 19.6769 4.43237 19.9622 4.43119 20.6632C4.43106 21.0648 4.76079 21.3963 5.16565 21.3945L5.93571 21.3916C6.29077 21.3962 6.57797 21.1055 6.5826 20.7504L6.58272 20.6656C6.58055 19.9665 7.0757 19.6806 7.68342 20.0301L7.7569 20.0724C8.06677 20.246 8.46209 20.1426 8.63563 19.8328L9.02319 19.1674C9.2272 18.8176 9.10493 18.3663 8.75709 18.1657C8.14937 17.8161 8.14971 17.245 8.75527 16.8953C9.10323 16.6945 9.22678 16.244 9.02396 15.8927L8.684 15.3039C8.48311 14.9559 8.03258 14.8324 7.6813 15.0352C7.07574 15.3848 6.5809 15.0995 6.5821 14.3985C6.58032 13.9936 6.25253 13.6654 5.84762 13.6671L5.07761 13.6701C4.72251 13.6654 4.43534 13.9561 4.43069 14.3112L4.43059 14.396C4.43275 15.0952 3.93759 15.381 3.32988 15.0315L3.25637 14.9892C2.94653 14.8157 2.55119 14.919 2.37767 15.2289L1.99011 15.8943C1.78609 16.244 1.90838 16.6954 2.2562 16.896C2.86391 17.2455 2.86358 17.8167 2.25802 18.1663C1.90673 18.3691 1.78847 18.821 1.98935 19.169Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7606 17.5306C6.7606 18.224 6.19847 18.7861 5.50506 18.7861C4.81164 18.7861 4.24951 18.224 4.24951 17.5306C4.24951 16.8372 4.81164 16.275 5.50506 16.275C6.19847 16.275 6.7606 16.8372 6.7606 17.5306Z",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimize);
export default __webpack_public_path__ + "static/media/optimize.4fdf121e660df92528850c29a566f61e.svg";
export { ForwardRef as ReactComponent };